/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ARouteRouteImport } from './routes/a/route'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as AuthCadastroRouteImport } from './routes/auth/cadastro'
import { Route as AuthCadastroFimRouteImport } from './routes/auth/cadastro-fim'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthRecuperarSenhaRouteImport } from './routes/auth/recuperar-senha'
import { Route as AuthRedefinirSenhaRouteImport } from './routes/auth/redefinir-senha'
import { Route as AConfiguracaoEmpresaRouteRouteImport } from './routes/a/configuracao/empresa/route'
import { Route as ARelatoriosAnaliseQualidadeRouteImport } from './routes/a/relatorios/analise-qualidade'
import { Route as ARelatoriosCadastroProdutorRouteImport } from './routes/a/relatorios/cadastro-produtor'
import { Route as ARelatoriosCadastroProdutorSimpRouteImport } from './routes/a/relatorios/cadastro-produtor-simp'
import { Route as ARelatoriosColetasCidadeRouteImport } from './routes/a/relatorios/coletas-cidade'
import { Route as ARelatoriosEntradaLeiteRouteImport } from './routes/a/relatorios/entrada-leite'
import { Route as ARelatoriosFichaProdutorRouteImport } from './routes/a/relatorios/ficha-produtor'
import { Route as ARelatoriosFinanceiroProdutorRouteImport } from './routes/a/relatorios/financeiro-produtor'
import { Route as ARelatoriosFunruralRouteImport } from './routes/a/relatorios/funrural'
import { Route as ARelatoriosLancamentosRouteImport } from './routes/a/relatorios/lancamentos'
import { Route as ARelatoriosLeiturasForaPadraoRouteImport } from './routes/a/relatorios/leituras-fora-padrao'
import { Route as ARelatoriosLitragemColetaRouteImport } from './routes/a/relatorios/litragem-coleta'
import { Route as ARelatoriosLitragemMensalRouteImport } from './routes/a/relatorios/litragem-mensal'
import { Route as ARelatoriosPagamentoProdutorRouteImport } from './routes/a/relatorios/pagamento-produtor'
import { Route as ARelatoriosProdutorFaixaLitragemRouteImport } from './routes/a/relatorios/produtor-faixa-litragem'
import { Route as ARelatoriosReferenciaRouteImport } from './routes/a/relatorios/referencia'
import { Route as PErroIndexRouteImport } from './routes/p/erro/index'
import { Route as AConfiguracaoEmpresaIndexRouteImport } from './routes/a/configuracao/empresa/index'

const AuthAcessoNegadoLazyRouteImport = createFileRoute('/auth/acesso-negado')()
const AAnalisesIndexLazyRouteImport = createFileRoute('/a/analises/')()
const ABonificacoesIndexLazyRouteImport = createFileRoute('/a/bonificacoes/')()
const ACalculosIndexLazyRouteImport = createFileRoute('/a/calculos/')()
const AColetasIndexLazyRouteImport = createFileRoute('/a/coletas/')()
const AConveniosIndexLazyRouteImport = createFileRoute('/a/convenios/')()
const ADebugIndexLazyRouteImport = createFileRoute('/a/debug/')()
const AEmpresas_conveniadasIndexLazyRouteImport = createFileRoute(
  '/a/empresas_conveniadas/',
)()
const AFechamentoIndexLazyRouteImport = createFileRoute('/a/fechamento/')()
const AGraficosIndexLazyRouteImport = createFileRoute('/a/graficos/')()
const AMotoristaIndexLazyRouteImport = createFileRoute('/a/motorista/')()
const APainelGerencialIndexLazyRouteImport = createFileRoute(
  '/a/painel-gerencial/',
)()
const APreco_referenciaIndexLazyRouteImport = createFileRoute(
  '/a/preco_referencia/',
)()
const AProdutor_nfeIndexLazyRouteImport = createFileRoute('/a/produtor_nfe/')()
const AProdutoresIndexLazyRouteImport = createFileRoute('/a/produtores/')()
const APropriedadeIndexLazyRouteImport = createFileRoute('/a/propriedade/')()
const AReferenciasIndexLazyRouteImport = createFileRoute('/a/referencias/')()
const ARelatoriosIndexLazyRouteImport = createFileRoute('/a/relatorios/')()
const ARotasIndexLazyRouteImport = createFileRoute('/a/rotas/')()
const ASub_rotasIndexLazyRouteImport = createFileRoute('/a/sub_rotas/')()
const ASuporteIndexLazyRouteImport = createFileRoute('/a/suporte/')()
const AUsuario_rotasIndexLazyRouteImport =
  createFileRoute('/a/usuario_rotas/')()
const AVeiculoIndexLazyRouteImport = createFileRoute('/a/veiculo/')()
const PApiDocsIndexLazyRouteImport = createFileRoute('/p/api-docs/')()

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ARouteRoute = ARouteRouteImport.update({
  id: '/a',
  path: '/a',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAcessoNegadoLazyRoute = AuthAcessoNegadoLazyRouteImport.update({
  id: '/acesso-negado',
  path: '/acesso-negado',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/auth/acesso-negado.lazy').then((d) => d.Route),
)
const AuthCadastroRoute = AuthCadastroRouteImport.update({
  id: '/cadastro',
  path: '/cadastro',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() => import('./routes/auth/cadastro.lazy').then((d) => d.Route))
const AuthCadastroFimRoute = AuthCadastroFimRouteImport.update({
  id: '/cadastro-fim',
  path: '/cadastro-fim',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/auth/cadastro-fim.lazy').then((d) => d.Route),
)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() => import('./routes/auth/login.lazy').then((d) => d.Route))
const AuthRecuperarSenhaRoute = AuthRecuperarSenhaRouteImport.update({
  id: '/recuperar-senha',
  path: '/recuperar-senha',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/auth/recuperar-senha.lazy').then((d) => d.Route),
)
const AuthRedefinirSenhaRoute = AuthRedefinirSenhaRouteImport.update({
  id: '/redefinir-senha',
  path: '/redefinir-senha',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/auth/redefinir-senha.lazy').then((d) => d.Route),
)
const AAnalisesIndexLazyRoute = AAnalisesIndexLazyRouteImport.update({
  id: '/analises/',
  path: '/analises/',
  getParentRoute: () => ARouteRoute,
} as any).lazy(() =>
  import('./routes/a/analises/index.lazy').then((d) => d.Route),
)
const ABonificacoesIndexLazyRoute = ABonificacoesIndexLazyRouteImport.update({
  id: '/bonificacoes/',
  path: '/bonificacoes/',
  getParentRoute: () => ARouteRoute,
} as any).lazy(() =>
  import('./routes/a/bonificacoes/index.lazy').then((d) => d.Route),
)
const ACalculosIndexLazyRoute = ACalculosIndexLazyRouteImport.update({
  id: '/calculos/',
  path: '/calculos/',
  getParentRoute: () => ARouteRoute,
} as any).lazy(() =>
  import('./routes/a/calculos/index.lazy').then((d) => d.Route),
)
const AColetasIndexLazyRoute = AColetasIndexLazyRouteImport.update({
  id: '/coletas/',
  path: '/coletas/',
  getParentRoute: () => ARouteRoute,
} as any).lazy(() =>
  import('./routes/a/coletas/index.lazy').then((d) => d.Route),
)
const AConfiguracaoEmpresaRouteRoute =
  AConfiguracaoEmpresaRouteRouteImport.update({
    id: '/configuracao/empresa',
    path: '/configuracao/empresa',
    getParentRoute: () => ARouteRoute,
  } as any)
const AConveniosIndexLazyRoute = AConveniosIndexLazyRouteImport.update({
  id: '/convenios/',
  path: '/convenios/',
  getParentRoute: () => ARouteRoute,
} as any).lazy(() =>
  import('./routes/a/convenios/index.lazy').then((d) => d.Route),
)
const ADebugIndexLazyRoute = ADebugIndexLazyRouteImport.update({
  id: '/debug/',
  path: '/debug/',
  getParentRoute: () => ARouteRoute,
} as any).lazy(() => import('./routes/a/debug/index.lazy').then((d) => d.Route))
const AEmpresas_conveniadasIndexLazyRoute =
  AEmpresas_conveniadasIndexLazyRouteImport.update({
    id: '/empresas_conveniadas/',
    path: '/empresas_conveniadas/',
    getParentRoute: () => ARouteRoute,
  } as any).lazy(() =>
    import('./routes/a/empresas_conveniadas/index.lazy').then((d) => d.Route),
  )
const AFechamentoIndexLazyRoute = AFechamentoIndexLazyRouteImport.update({
  id: '/fechamento/',
  path: '/fechamento/',
  getParentRoute: () => ARouteRoute,
} as any).lazy(() =>
  import('./routes/a/fechamento/index.lazy').then((d) => d.Route),
)
const AGraficosIndexLazyRoute = AGraficosIndexLazyRouteImport.update({
  id: '/graficos/',
  path: '/graficos/',
  getParentRoute: () => ARouteRoute,
} as any).lazy(() =>
  import('./routes/a/graficos/index.lazy').then((d) => d.Route),
)
const AMotoristaIndexLazyRoute = AMotoristaIndexLazyRouteImport.update({
  id: '/motorista/',
  path: '/motorista/',
  getParentRoute: () => ARouteRoute,
} as any).lazy(() =>
  import('./routes/a/motorista/index.lazy').then((d) => d.Route),
)
const APainelGerencialIndexLazyRoute =
  APainelGerencialIndexLazyRouteImport.update({
    id: '/painel-gerencial/',
    path: '/painel-gerencial/',
    getParentRoute: () => ARouteRoute,
  } as any).lazy(() =>
    import('./routes/a/painel-gerencial/index.lazy').then((d) => d.Route),
  )
const APreco_referenciaIndexLazyRoute =
  APreco_referenciaIndexLazyRouteImport.update({
    id: '/preco_referencia/',
    path: '/preco_referencia/',
    getParentRoute: () => ARouteRoute,
  } as any).lazy(() =>
    import('./routes/a/preco_referencia/index.lazy').then((d) => d.Route),
  )
const AProdutor_nfeIndexLazyRoute = AProdutor_nfeIndexLazyRouteImport.update({
  id: '/produtor_nfe/',
  path: '/produtor_nfe/',
  getParentRoute: () => ARouteRoute,
} as any).lazy(() =>
  import('./routes/a/produtor_nfe/index.lazy').then((d) => d.Route),
)
const AProdutoresIndexLazyRoute = AProdutoresIndexLazyRouteImport.update({
  id: '/produtores/',
  path: '/produtores/',
  getParentRoute: () => ARouteRoute,
} as any).lazy(() =>
  import('./routes/a/produtores/index.lazy').then((d) => d.Route),
)
const APropriedadeIndexLazyRoute = APropriedadeIndexLazyRouteImport.update({
  id: '/propriedade/',
  path: '/propriedade/',
  getParentRoute: () => ARouteRoute,
} as any).lazy(() =>
  import('./routes/a/propriedade/index.lazy').then((d) => d.Route),
)
const AReferenciasIndexLazyRoute = AReferenciasIndexLazyRouteImport.update({
  id: '/referencias/',
  path: '/referencias/',
  getParentRoute: () => ARouteRoute,
} as any).lazy(() =>
  import('./routes/a/referencias/index.lazy').then((d) => d.Route),
)
const ARelatoriosIndexLazyRoute = ARelatoriosIndexLazyRouteImport.update({
  id: '/relatorios/',
  path: '/relatorios/',
  getParentRoute: () => ARouteRoute,
} as any).lazy(() =>
  import('./routes/a/relatorios/index.lazy').then((d) => d.Route),
)
const ARelatoriosAnaliseQualidadeRoute =
  ARelatoriosAnaliseQualidadeRouteImport.update({
    id: '/relatorios/analise-qualidade',
    path: '/relatorios/analise-qualidade',
    getParentRoute: () => ARouteRoute,
  } as any)
const ARelatoriosCadastroProdutorRoute =
  ARelatoriosCadastroProdutorRouteImport.update({
    id: '/relatorios/cadastro-produtor',
    path: '/relatorios/cadastro-produtor',
    getParentRoute: () => ARouteRoute,
  } as any)
const ARelatoriosCadastroProdutorSimpRoute =
  ARelatoriosCadastroProdutorSimpRouteImport.update({
    id: '/relatorios/cadastro-produtor-simp',
    path: '/relatorios/cadastro-produtor-simp',
    getParentRoute: () => ARouteRoute,
  } as any)
const ARelatoriosColetasCidadeRoute =
  ARelatoriosColetasCidadeRouteImport.update({
    id: '/relatorios/coletas-cidade',
    path: '/relatorios/coletas-cidade',
    getParentRoute: () => ARouteRoute,
  } as any)
const ARelatoriosEntradaLeiteRoute = ARelatoriosEntradaLeiteRouteImport.update({
  id: '/relatorios/entrada-leite',
  path: '/relatorios/entrada-leite',
  getParentRoute: () => ARouteRoute,
} as any)
const ARelatoriosFichaProdutorRoute =
  ARelatoriosFichaProdutorRouteImport.update({
    id: '/relatorios/ficha-produtor',
    path: '/relatorios/ficha-produtor',
    getParentRoute: () => ARouteRoute,
  } as any)
const ARelatoriosFinanceiroProdutorRoute =
  ARelatoriosFinanceiroProdutorRouteImport.update({
    id: '/relatorios/financeiro-produtor',
    path: '/relatorios/financeiro-produtor',
    getParentRoute: () => ARouteRoute,
  } as any)
const ARelatoriosFunruralRoute = ARelatoriosFunruralRouteImport.update({
  id: '/relatorios/funrural',
  path: '/relatorios/funrural',
  getParentRoute: () => ARouteRoute,
} as any)
const ARelatoriosLancamentosRoute = ARelatoriosLancamentosRouteImport.update({
  id: '/relatorios/lancamentos',
  path: '/relatorios/lancamentos',
  getParentRoute: () => ARouteRoute,
} as any)
const ARelatoriosLeiturasForaPadraoRoute =
  ARelatoriosLeiturasForaPadraoRouteImport.update({
    id: '/relatorios/leituras-fora-padrao',
    path: '/relatorios/leituras-fora-padrao',
    getParentRoute: () => ARouteRoute,
  } as any)
const ARelatoriosLitragemColetaRoute =
  ARelatoriosLitragemColetaRouteImport.update({
    id: '/relatorios/litragem-coleta',
    path: '/relatorios/litragem-coleta',
    getParentRoute: () => ARouteRoute,
  } as any)
const ARelatoriosLitragemMensalRoute =
  ARelatoriosLitragemMensalRouteImport.update({
    id: '/relatorios/litragem-mensal',
    path: '/relatorios/litragem-mensal',
    getParentRoute: () => ARouteRoute,
  } as any)
const ARelatoriosPagamentoProdutorRoute =
  ARelatoriosPagamentoProdutorRouteImport.update({
    id: '/relatorios/pagamento-produtor',
    path: '/relatorios/pagamento-produtor',
    getParentRoute: () => ARouteRoute,
  } as any)
const ARelatoriosProdutorFaixaLitragemRoute =
  ARelatoriosProdutorFaixaLitragemRouteImport.update({
    id: '/relatorios/produtor-faixa-litragem',
    path: '/relatorios/produtor-faixa-litragem',
    getParentRoute: () => ARouteRoute,
  } as any)
const ARelatoriosReferenciaRoute = ARelatoriosReferenciaRouteImport.update({
  id: '/relatorios/referencia',
  path: '/relatorios/referencia',
  getParentRoute: () => ARouteRoute,
} as any)
const ARotasIndexLazyRoute = ARotasIndexLazyRouteImport.update({
  id: '/rotas/',
  path: '/rotas/',
  getParentRoute: () => ARouteRoute,
} as any).lazy(() => import('./routes/a/rotas/index.lazy').then((d) => d.Route))
const ASub_rotasIndexLazyRoute = ASub_rotasIndexLazyRouteImport.update({
  id: '/sub_rotas/',
  path: '/sub_rotas/',
  getParentRoute: () => ARouteRoute,
} as any).lazy(() =>
  import('./routes/a/sub_rotas/index.lazy').then((d) => d.Route),
)
const ASuporteIndexLazyRoute = ASuporteIndexLazyRouteImport.update({
  id: '/suporte/',
  path: '/suporte/',
  getParentRoute: () => ARouteRoute,
} as any).lazy(() =>
  import('./routes/a/suporte/index.lazy').then((d) => d.Route),
)
const AUsuario_rotasIndexLazyRoute = AUsuario_rotasIndexLazyRouteImport.update({
  id: '/usuario_rotas/',
  path: '/usuario_rotas/',
  getParentRoute: () => ARouteRoute,
} as any).lazy(() =>
  import('./routes/a/usuario_rotas/index.lazy').then((d) => d.Route),
)
const AVeiculoIndexLazyRoute = AVeiculoIndexLazyRouteImport.update({
  id: '/veiculo/',
  path: '/veiculo/',
  getParentRoute: () => ARouteRoute,
} as any).lazy(() =>
  import('./routes/a/veiculo/index.lazy').then((d) => d.Route),
)
const PApiDocsIndexLazyRoute = PApiDocsIndexLazyRouteImport.update({
  id: '/p/api-docs/',
  path: '/p/api-docs/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/p/api-docs/index.lazy').then((d) => d.Route),
)
const PErroIndexRoute = PErroIndexRouteImport.update({
  id: '/p/erro/',
  path: '/p/erro/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/p/erro/index.lazy').then((d) => d.Route))
const AConfiguracaoEmpresaIndexRoute =
  AConfiguracaoEmpresaIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AConfiguracaoEmpresaRouteRoute,
  } as any).lazy(() =>
    import('./routes/a/configuracao/empresa/index.lazy').then((d) => d.Route),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/a': typeof ARouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/auth/cadastro': typeof AuthCadastroRoute
  '/auth/cadastro-fim': typeof AuthCadastroFimRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/recuperar-senha': typeof AuthRecuperarSenhaRoute
  '/auth/redefinir-senha': typeof AuthRedefinirSenhaRoute
  '/auth/acesso-negado': typeof AuthAcessoNegadoLazyRoute
  '/a/configuracao/empresa': typeof AConfiguracaoEmpresaRouteRouteWithChildren
  '/a/relatorios/analise-qualidade': typeof ARelatoriosAnaliseQualidadeRoute
  '/a/relatorios/cadastro-produtor': typeof ARelatoriosCadastroProdutorRoute
  '/a/relatorios/cadastro-produtor-simp': typeof ARelatoriosCadastroProdutorSimpRoute
  '/a/relatorios/coletas-cidade': typeof ARelatoriosColetasCidadeRoute
  '/a/relatorios/entrada-leite': typeof ARelatoriosEntradaLeiteRoute
  '/a/relatorios/ficha-produtor': typeof ARelatoriosFichaProdutorRoute
  '/a/relatorios/financeiro-produtor': typeof ARelatoriosFinanceiroProdutorRoute
  '/a/relatorios/funrural': typeof ARelatoriosFunruralRoute
  '/a/relatorios/lancamentos': typeof ARelatoriosLancamentosRoute
  '/a/relatorios/leituras-fora-padrao': typeof ARelatoriosLeiturasForaPadraoRoute
  '/a/relatorios/litragem-coleta': typeof ARelatoriosLitragemColetaRoute
  '/a/relatorios/litragem-mensal': typeof ARelatoriosLitragemMensalRoute
  '/a/relatorios/pagamento-produtor': typeof ARelatoriosPagamentoProdutorRoute
  '/a/relatorios/produtor-faixa-litragem': typeof ARelatoriosProdutorFaixaLitragemRoute
  '/a/relatorios/referencia': typeof ARelatoriosReferenciaRoute
  '/p/erro/': typeof PErroIndexRoute
  '/a/analises/': typeof AAnalisesIndexLazyRoute
  '/a/bonificacoes/': typeof ABonificacoesIndexLazyRoute
  '/a/calculos/': typeof ACalculosIndexLazyRoute
  '/a/coletas/': typeof AColetasIndexLazyRoute
  '/a/convenios/': typeof AConveniosIndexLazyRoute
  '/a/debug/': typeof ADebugIndexLazyRoute
  '/a/empresas_conveniadas/': typeof AEmpresas_conveniadasIndexLazyRoute
  '/a/fechamento/': typeof AFechamentoIndexLazyRoute
  '/a/graficos/': typeof AGraficosIndexLazyRoute
  '/a/motorista/': typeof AMotoristaIndexLazyRoute
  '/a/painel-gerencial/': typeof APainelGerencialIndexLazyRoute
  '/a/preco_referencia/': typeof APreco_referenciaIndexLazyRoute
  '/a/produtor_nfe/': typeof AProdutor_nfeIndexLazyRoute
  '/a/produtores/': typeof AProdutoresIndexLazyRoute
  '/a/propriedade/': typeof APropriedadeIndexLazyRoute
  '/a/referencias/': typeof AReferenciasIndexLazyRoute
  '/a/relatorios/': typeof ARelatoriosIndexLazyRoute
  '/a/rotas/': typeof ARotasIndexLazyRoute
  '/a/sub_rotas/': typeof ASub_rotasIndexLazyRoute
  '/a/suporte/': typeof ASuporteIndexLazyRoute
  '/a/usuario_rotas/': typeof AUsuario_rotasIndexLazyRoute
  '/a/veiculo/': typeof AVeiculoIndexLazyRoute
  '/p/api-docs/': typeof PApiDocsIndexLazyRoute
  '/a/configuracao/empresa/': typeof AConfiguracaoEmpresaIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/a': typeof ARouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/auth/cadastro': typeof AuthCadastroRoute
  '/auth/cadastro-fim': typeof AuthCadastroFimRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/recuperar-senha': typeof AuthRecuperarSenhaRoute
  '/auth/redefinir-senha': typeof AuthRedefinirSenhaRoute
  '/auth/acesso-negado': typeof AuthAcessoNegadoLazyRoute
  '/a/relatorios/analise-qualidade': typeof ARelatoriosAnaliseQualidadeRoute
  '/a/relatorios/cadastro-produtor': typeof ARelatoriosCadastroProdutorRoute
  '/a/relatorios/cadastro-produtor-simp': typeof ARelatoriosCadastroProdutorSimpRoute
  '/a/relatorios/coletas-cidade': typeof ARelatoriosColetasCidadeRoute
  '/a/relatorios/entrada-leite': typeof ARelatoriosEntradaLeiteRoute
  '/a/relatorios/ficha-produtor': typeof ARelatoriosFichaProdutorRoute
  '/a/relatorios/financeiro-produtor': typeof ARelatoriosFinanceiroProdutorRoute
  '/a/relatorios/funrural': typeof ARelatoriosFunruralRoute
  '/a/relatorios/lancamentos': typeof ARelatoriosLancamentosRoute
  '/a/relatorios/leituras-fora-padrao': typeof ARelatoriosLeiturasForaPadraoRoute
  '/a/relatorios/litragem-coleta': typeof ARelatoriosLitragemColetaRoute
  '/a/relatorios/litragem-mensal': typeof ARelatoriosLitragemMensalRoute
  '/a/relatorios/pagamento-produtor': typeof ARelatoriosPagamentoProdutorRoute
  '/a/relatorios/produtor-faixa-litragem': typeof ARelatoriosProdutorFaixaLitragemRoute
  '/a/relatorios/referencia': typeof ARelatoriosReferenciaRoute
  '/p/erro': typeof PErroIndexRoute
  '/a/analises': typeof AAnalisesIndexLazyRoute
  '/a/bonificacoes': typeof ABonificacoesIndexLazyRoute
  '/a/calculos': typeof ACalculosIndexLazyRoute
  '/a/coletas': typeof AColetasIndexLazyRoute
  '/a/convenios': typeof AConveniosIndexLazyRoute
  '/a/debug': typeof ADebugIndexLazyRoute
  '/a/empresas_conveniadas': typeof AEmpresas_conveniadasIndexLazyRoute
  '/a/fechamento': typeof AFechamentoIndexLazyRoute
  '/a/graficos': typeof AGraficosIndexLazyRoute
  '/a/motorista': typeof AMotoristaIndexLazyRoute
  '/a/painel-gerencial': typeof APainelGerencialIndexLazyRoute
  '/a/preco_referencia': typeof APreco_referenciaIndexLazyRoute
  '/a/produtor_nfe': typeof AProdutor_nfeIndexLazyRoute
  '/a/produtores': typeof AProdutoresIndexLazyRoute
  '/a/propriedade': typeof APropriedadeIndexLazyRoute
  '/a/referencias': typeof AReferenciasIndexLazyRoute
  '/a/relatorios': typeof ARelatoriosIndexLazyRoute
  '/a/rotas': typeof ARotasIndexLazyRoute
  '/a/sub_rotas': typeof ASub_rotasIndexLazyRoute
  '/a/suporte': typeof ASuporteIndexLazyRoute
  '/a/usuario_rotas': typeof AUsuario_rotasIndexLazyRoute
  '/a/veiculo': typeof AVeiculoIndexLazyRoute
  '/p/api-docs': typeof PApiDocsIndexLazyRoute
  '/a/configuracao/empresa': typeof AConfiguracaoEmpresaIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/a': typeof ARouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/auth/cadastro': typeof AuthCadastroRoute
  '/auth/cadastro-fim': typeof AuthCadastroFimRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/recuperar-senha': typeof AuthRecuperarSenhaRoute
  '/auth/redefinir-senha': typeof AuthRedefinirSenhaRoute
  '/auth/acesso-negado': typeof AuthAcessoNegadoLazyRoute
  '/a/configuracao/empresa': typeof AConfiguracaoEmpresaRouteRouteWithChildren
  '/a/relatorios/analise-qualidade': typeof ARelatoriosAnaliseQualidadeRoute
  '/a/relatorios/cadastro-produtor': typeof ARelatoriosCadastroProdutorRoute
  '/a/relatorios/cadastro-produtor-simp': typeof ARelatoriosCadastroProdutorSimpRoute
  '/a/relatorios/coletas-cidade': typeof ARelatoriosColetasCidadeRoute
  '/a/relatorios/entrada-leite': typeof ARelatoriosEntradaLeiteRoute
  '/a/relatorios/ficha-produtor': typeof ARelatoriosFichaProdutorRoute
  '/a/relatorios/financeiro-produtor': typeof ARelatoriosFinanceiroProdutorRoute
  '/a/relatorios/funrural': typeof ARelatoriosFunruralRoute
  '/a/relatorios/lancamentos': typeof ARelatoriosLancamentosRoute
  '/a/relatorios/leituras-fora-padrao': typeof ARelatoriosLeiturasForaPadraoRoute
  '/a/relatorios/litragem-coleta': typeof ARelatoriosLitragemColetaRoute
  '/a/relatorios/litragem-mensal': typeof ARelatoriosLitragemMensalRoute
  '/a/relatorios/pagamento-produtor': typeof ARelatoriosPagamentoProdutorRoute
  '/a/relatorios/produtor-faixa-litragem': typeof ARelatoriosProdutorFaixaLitragemRoute
  '/a/relatorios/referencia': typeof ARelatoriosReferenciaRoute
  '/p/erro/': typeof PErroIndexRoute
  '/a/analises/': typeof AAnalisesIndexLazyRoute
  '/a/bonificacoes/': typeof ABonificacoesIndexLazyRoute
  '/a/calculos/': typeof ACalculosIndexLazyRoute
  '/a/coletas/': typeof AColetasIndexLazyRoute
  '/a/convenios/': typeof AConveniosIndexLazyRoute
  '/a/debug/': typeof ADebugIndexLazyRoute
  '/a/empresas_conveniadas/': typeof AEmpresas_conveniadasIndexLazyRoute
  '/a/fechamento/': typeof AFechamentoIndexLazyRoute
  '/a/graficos/': typeof AGraficosIndexLazyRoute
  '/a/motorista/': typeof AMotoristaIndexLazyRoute
  '/a/painel-gerencial/': typeof APainelGerencialIndexLazyRoute
  '/a/preco_referencia/': typeof APreco_referenciaIndexLazyRoute
  '/a/produtor_nfe/': typeof AProdutor_nfeIndexLazyRoute
  '/a/produtores/': typeof AProdutoresIndexLazyRoute
  '/a/propriedade/': typeof APropriedadeIndexLazyRoute
  '/a/referencias/': typeof AReferenciasIndexLazyRoute
  '/a/relatorios/': typeof ARelatoriosIndexLazyRoute
  '/a/rotas/': typeof ARotasIndexLazyRoute
  '/a/sub_rotas/': typeof ASub_rotasIndexLazyRoute
  '/a/suporte/': typeof ASuporteIndexLazyRoute
  '/a/usuario_rotas/': typeof AUsuario_rotasIndexLazyRoute
  '/a/veiculo/': typeof AVeiculoIndexLazyRoute
  '/p/api-docs/': typeof PApiDocsIndexLazyRoute
  '/a/configuracao/empresa/': typeof AConfiguracaoEmpresaIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/a'
    | '/auth'
    | '/auth/cadastro'
    | '/auth/cadastro-fim'
    | '/auth/login'
    | '/auth/recuperar-senha'
    | '/auth/redefinir-senha'
    | '/auth/acesso-negado'
    | '/a/configuracao/empresa'
    | '/a/relatorios/analise-qualidade'
    | '/a/relatorios/cadastro-produtor'
    | '/a/relatorios/cadastro-produtor-simp'
    | '/a/relatorios/coletas-cidade'
    | '/a/relatorios/entrada-leite'
    | '/a/relatorios/ficha-produtor'
    | '/a/relatorios/financeiro-produtor'
    | '/a/relatorios/funrural'
    | '/a/relatorios/lancamentos'
    | '/a/relatorios/leituras-fora-padrao'
    | '/a/relatorios/litragem-coleta'
    | '/a/relatorios/litragem-mensal'
    | '/a/relatorios/pagamento-produtor'
    | '/a/relatorios/produtor-faixa-litragem'
    | '/a/relatorios/referencia'
    | '/p/erro/'
    | '/a/analises/'
    | '/a/bonificacoes/'
    | '/a/calculos/'
    | '/a/coletas/'
    | '/a/convenios/'
    | '/a/debug/'
    | '/a/empresas_conveniadas/'
    | '/a/fechamento/'
    | '/a/graficos/'
    | '/a/motorista/'
    | '/a/painel-gerencial/'
    | '/a/preco_referencia/'
    | '/a/produtor_nfe/'
    | '/a/produtores/'
    | '/a/propriedade/'
    | '/a/referencias/'
    | '/a/relatorios/'
    | '/a/rotas/'
    | '/a/sub_rotas/'
    | '/a/suporte/'
    | '/a/usuario_rotas/'
    | '/a/veiculo/'
    | '/p/api-docs/'
    | '/a/configuracao/empresa/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/a'
    | '/auth'
    | '/auth/cadastro'
    | '/auth/cadastro-fim'
    | '/auth/login'
    | '/auth/recuperar-senha'
    | '/auth/redefinir-senha'
    | '/auth/acesso-negado'
    | '/a/relatorios/analise-qualidade'
    | '/a/relatorios/cadastro-produtor'
    | '/a/relatorios/cadastro-produtor-simp'
    | '/a/relatorios/coletas-cidade'
    | '/a/relatorios/entrada-leite'
    | '/a/relatorios/ficha-produtor'
    | '/a/relatorios/financeiro-produtor'
    | '/a/relatorios/funrural'
    | '/a/relatorios/lancamentos'
    | '/a/relatorios/leituras-fora-padrao'
    | '/a/relatorios/litragem-coleta'
    | '/a/relatorios/litragem-mensal'
    | '/a/relatorios/pagamento-produtor'
    | '/a/relatorios/produtor-faixa-litragem'
    | '/a/relatorios/referencia'
    | '/p/erro'
    | '/a/analises'
    | '/a/bonificacoes'
    | '/a/calculos'
    | '/a/coletas'
    | '/a/convenios'
    | '/a/debug'
    | '/a/empresas_conveniadas'
    | '/a/fechamento'
    | '/a/graficos'
    | '/a/motorista'
    | '/a/painel-gerencial'
    | '/a/preco_referencia'
    | '/a/produtor_nfe'
    | '/a/produtores'
    | '/a/propriedade'
    | '/a/referencias'
    | '/a/relatorios'
    | '/a/rotas'
    | '/a/sub_rotas'
    | '/a/suporte'
    | '/a/usuario_rotas'
    | '/a/veiculo'
    | '/p/api-docs'
    | '/a/configuracao/empresa'
  id:
    | '__root__'
    | '/'
    | '/a'
    | '/auth'
    | '/auth/cadastro'
    | '/auth/cadastro-fim'
    | '/auth/login'
    | '/auth/recuperar-senha'
    | '/auth/redefinir-senha'
    | '/auth/acesso-negado'
    | '/a/configuracao/empresa'
    | '/a/relatorios/analise-qualidade'
    | '/a/relatorios/cadastro-produtor'
    | '/a/relatorios/cadastro-produtor-simp'
    | '/a/relatorios/coletas-cidade'
    | '/a/relatorios/entrada-leite'
    | '/a/relatorios/ficha-produtor'
    | '/a/relatorios/financeiro-produtor'
    | '/a/relatorios/funrural'
    | '/a/relatorios/lancamentos'
    | '/a/relatorios/leituras-fora-padrao'
    | '/a/relatorios/litragem-coleta'
    | '/a/relatorios/litragem-mensal'
    | '/a/relatorios/pagamento-produtor'
    | '/a/relatorios/produtor-faixa-litragem'
    | '/a/relatorios/referencia'
    | '/p/erro/'
    | '/a/analises/'
    | '/a/bonificacoes/'
    | '/a/calculos/'
    | '/a/coletas/'
    | '/a/convenios/'
    | '/a/debug/'
    | '/a/empresas_conveniadas/'
    | '/a/fechamento/'
    | '/a/graficos/'
    | '/a/motorista/'
    | '/a/painel-gerencial/'
    | '/a/preco_referencia/'
    | '/a/produtor_nfe/'
    | '/a/produtores/'
    | '/a/propriedade/'
    | '/a/referencias/'
    | '/a/relatorios/'
    | '/a/rotas/'
    | '/a/sub_rotas/'
    | '/a/suporte/'
    | '/a/usuario_rotas/'
    | '/a/veiculo/'
    | '/p/api-docs/'
    | '/a/configuracao/empresa/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ARouteRoute: typeof ARouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  PErroIndexRoute: typeof PErroIndexRoute
  PApiDocsIndexLazyRoute: typeof PApiDocsIndexLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/a': {
      id: '/a'
      path: '/a'
      fullPath: '/a'
      preLoaderRoute: typeof ARouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/acesso-negado': {
      id: '/auth/acesso-negado'
      path: '/acesso-negado'
      fullPath: '/auth/acesso-negado'
      preLoaderRoute: typeof AuthAcessoNegadoLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/cadastro': {
      id: '/auth/cadastro'
      path: '/cadastro'
      fullPath: '/auth/cadastro'
      preLoaderRoute: typeof AuthCadastroRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/cadastro-fim': {
      id: '/auth/cadastro-fim'
      path: '/cadastro-fim'
      fullPath: '/auth/cadastro-fim'
      preLoaderRoute: typeof AuthCadastroFimRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/recuperar-senha': {
      id: '/auth/recuperar-senha'
      path: '/recuperar-senha'
      fullPath: '/auth/recuperar-senha'
      preLoaderRoute: typeof AuthRecuperarSenhaRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/redefinir-senha': {
      id: '/auth/redefinir-senha'
      path: '/redefinir-senha'
      fullPath: '/auth/redefinir-senha'
      preLoaderRoute: typeof AuthRedefinirSenhaRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/a/analises/': {
      id: '/a/analises/'
      path: '/analises'
      fullPath: '/a/analises/'
      preLoaderRoute: typeof AAnalisesIndexLazyRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/bonificacoes/': {
      id: '/a/bonificacoes/'
      path: '/bonificacoes'
      fullPath: '/a/bonificacoes/'
      preLoaderRoute: typeof ABonificacoesIndexLazyRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/calculos/': {
      id: '/a/calculos/'
      path: '/calculos'
      fullPath: '/a/calculos/'
      preLoaderRoute: typeof ACalculosIndexLazyRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/coletas/': {
      id: '/a/coletas/'
      path: '/coletas'
      fullPath: '/a/coletas/'
      preLoaderRoute: typeof AColetasIndexLazyRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/configuracao/empresa': {
      id: '/a/configuracao/empresa'
      path: '/configuracao/empresa'
      fullPath: '/a/configuracao/empresa'
      preLoaderRoute: typeof AConfiguracaoEmpresaRouteRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/convenios/': {
      id: '/a/convenios/'
      path: '/convenios'
      fullPath: '/a/convenios/'
      preLoaderRoute: typeof AConveniosIndexLazyRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/debug/': {
      id: '/a/debug/'
      path: '/debug'
      fullPath: '/a/debug/'
      preLoaderRoute: typeof ADebugIndexLazyRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/empresas_conveniadas/': {
      id: '/a/empresas_conveniadas/'
      path: '/empresas_conveniadas'
      fullPath: '/a/empresas_conveniadas/'
      preLoaderRoute: typeof AEmpresas_conveniadasIndexLazyRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/fechamento/': {
      id: '/a/fechamento/'
      path: '/fechamento'
      fullPath: '/a/fechamento/'
      preLoaderRoute: typeof AFechamentoIndexLazyRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/graficos/': {
      id: '/a/graficos/'
      path: '/graficos'
      fullPath: '/a/graficos/'
      preLoaderRoute: typeof AGraficosIndexLazyRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/motorista/': {
      id: '/a/motorista/'
      path: '/motorista'
      fullPath: '/a/motorista/'
      preLoaderRoute: typeof AMotoristaIndexLazyRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/painel-gerencial/': {
      id: '/a/painel-gerencial/'
      path: '/painel-gerencial'
      fullPath: '/a/painel-gerencial/'
      preLoaderRoute: typeof APainelGerencialIndexLazyRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/preco_referencia/': {
      id: '/a/preco_referencia/'
      path: '/preco_referencia'
      fullPath: '/a/preco_referencia/'
      preLoaderRoute: typeof APreco_referenciaIndexLazyRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/produtor_nfe/': {
      id: '/a/produtor_nfe/'
      path: '/produtor_nfe'
      fullPath: '/a/produtor_nfe/'
      preLoaderRoute: typeof AProdutor_nfeIndexLazyRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/produtores/': {
      id: '/a/produtores/'
      path: '/produtores'
      fullPath: '/a/produtores/'
      preLoaderRoute: typeof AProdutoresIndexLazyRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/propriedade/': {
      id: '/a/propriedade/'
      path: '/propriedade'
      fullPath: '/a/propriedade/'
      preLoaderRoute: typeof APropriedadeIndexLazyRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/referencias/': {
      id: '/a/referencias/'
      path: '/referencias'
      fullPath: '/a/referencias/'
      preLoaderRoute: typeof AReferenciasIndexLazyRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/relatorios/': {
      id: '/a/relatorios/'
      path: '/relatorios'
      fullPath: '/a/relatorios/'
      preLoaderRoute: typeof ARelatoriosIndexLazyRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/relatorios/analise-qualidade': {
      id: '/a/relatorios/analise-qualidade'
      path: '/relatorios/analise-qualidade'
      fullPath: '/a/relatorios/analise-qualidade'
      preLoaderRoute: typeof ARelatoriosAnaliseQualidadeRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/relatorios/cadastro-produtor': {
      id: '/a/relatorios/cadastro-produtor'
      path: '/relatorios/cadastro-produtor'
      fullPath: '/a/relatorios/cadastro-produtor'
      preLoaderRoute: typeof ARelatoriosCadastroProdutorRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/relatorios/cadastro-produtor-simp': {
      id: '/a/relatorios/cadastro-produtor-simp'
      path: '/relatorios/cadastro-produtor-simp'
      fullPath: '/a/relatorios/cadastro-produtor-simp'
      preLoaderRoute: typeof ARelatoriosCadastroProdutorSimpRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/relatorios/coletas-cidade': {
      id: '/a/relatorios/coletas-cidade'
      path: '/relatorios/coletas-cidade'
      fullPath: '/a/relatorios/coletas-cidade'
      preLoaderRoute: typeof ARelatoriosColetasCidadeRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/relatorios/entrada-leite': {
      id: '/a/relatorios/entrada-leite'
      path: '/relatorios/entrada-leite'
      fullPath: '/a/relatorios/entrada-leite'
      preLoaderRoute: typeof ARelatoriosEntradaLeiteRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/relatorios/ficha-produtor': {
      id: '/a/relatorios/ficha-produtor'
      path: '/relatorios/ficha-produtor'
      fullPath: '/a/relatorios/ficha-produtor'
      preLoaderRoute: typeof ARelatoriosFichaProdutorRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/relatorios/financeiro-produtor': {
      id: '/a/relatorios/financeiro-produtor'
      path: '/relatorios/financeiro-produtor'
      fullPath: '/a/relatorios/financeiro-produtor'
      preLoaderRoute: typeof ARelatoriosFinanceiroProdutorRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/relatorios/funrural': {
      id: '/a/relatorios/funrural'
      path: '/relatorios/funrural'
      fullPath: '/a/relatorios/funrural'
      preLoaderRoute: typeof ARelatoriosFunruralRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/relatorios/lancamentos': {
      id: '/a/relatorios/lancamentos'
      path: '/relatorios/lancamentos'
      fullPath: '/a/relatorios/lancamentos'
      preLoaderRoute: typeof ARelatoriosLancamentosRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/relatorios/leituras-fora-padrao': {
      id: '/a/relatorios/leituras-fora-padrao'
      path: '/relatorios/leituras-fora-padrao'
      fullPath: '/a/relatorios/leituras-fora-padrao'
      preLoaderRoute: typeof ARelatoriosLeiturasForaPadraoRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/relatorios/litragem-coleta': {
      id: '/a/relatorios/litragem-coleta'
      path: '/relatorios/litragem-coleta'
      fullPath: '/a/relatorios/litragem-coleta'
      preLoaderRoute: typeof ARelatoriosLitragemColetaRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/relatorios/litragem-mensal': {
      id: '/a/relatorios/litragem-mensal'
      path: '/relatorios/litragem-mensal'
      fullPath: '/a/relatorios/litragem-mensal'
      preLoaderRoute: typeof ARelatoriosLitragemMensalRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/relatorios/pagamento-produtor': {
      id: '/a/relatorios/pagamento-produtor'
      path: '/relatorios/pagamento-produtor'
      fullPath: '/a/relatorios/pagamento-produtor'
      preLoaderRoute: typeof ARelatoriosPagamentoProdutorRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/relatorios/produtor-faixa-litragem': {
      id: '/a/relatorios/produtor-faixa-litragem'
      path: '/relatorios/produtor-faixa-litragem'
      fullPath: '/a/relatorios/produtor-faixa-litragem'
      preLoaderRoute: typeof ARelatoriosProdutorFaixaLitragemRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/relatorios/referencia': {
      id: '/a/relatorios/referencia'
      path: '/relatorios/referencia'
      fullPath: '/a/relatorios/referencia'
      preLoaderRoute: typeof ARelatoriosReferenciaRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/rotas/': {
      id: '/a/rotas/'
      path: '/rotas'
      fullPath: '/a/rotas/'
      preLoaderRoute: typeof ARotasIndexLazyRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/sub_rotas/': {
      id: '/a/sub_rotas/'
      path: '/sub_rotas'
      fullPath: '/a/sub_rotas/'
      preLoaderRoute: typeof ASub_rotasIndexLazyRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/suporte/': {
      id: '/a/suporte/'
      path: '/suporte'
      fullPath: '/a/suporte/'
      preLoaderRoute: typeof ASuporteIndexLazyRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/usuario_rotas/': {
      id: '/a/usuario_rotas/'
      path: '/usuario_rotas'
      fullPath: '/a/usuario_rotas/'
      preLoaderRoute: typeof AUsuario_rotasIndexLazyRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/a/veiculo/': {
      id: '/a/veiculo/'
      path: '/veiculo'
      fullPath: '/a/veiculo/'
      preLoaderRoute: typeof AVeiculoIndexLazyRouteImport
      parentRoute: typeof ARouteRoute
    }
    '/p/api-docs/': {
      id: '/p/api-docs/'
      path: '/p/api-docs'
      fullPath: '/p/api-docs/'
      preLoaderRoute: typeof PApiDocsIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/erro/': {
      id: '/p/erro/'
      path: '/p/erro'
      fullPath: '/p/erro/'
      preLoaderRoute: typeof PErroIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/a/configuracao/empresa/': {
      id: '/a/configuracao/empresa/'
      path: '/'
      fullPath: '/a/configuracao/empresa/'
      preLoaderRoute: typeof AConfiguracaoEmpresaIndexRouteImport
      parentRoute: typeof AConfiguracaoEmpresaRouteRoute
    }
  }
}

interface AConfiguracaoEmpresaRouteRouteChildren {
  AConfiguracaoEmpresaIndexRoute: typeof AConfiguracaoEmpresaIndexRoute
}

const AConfiguracaoEmpresaRouteRouteChildren: AConfiguracaoEmpresaRouteRouteChildren =
  {
    AConfiguracaoEmpresaIndexRoute: AConfiguracaoEmpresaIndexRoute,
  }

const AConfiguracaoEmpresaRouteRouteWithChildren =
  AConfiguracaoEmpresaRouteRoute._addFileChildren(
    AConfiguracaoEmpresaRouteRouteChildren,
  )

interface ARouteRouteChildren {
  AConfiguracaoEmpresaRouteRoute: typeof AConfiguracaoEmpresaRouteRouteWithChildren
  ARelatoriosAnaliseQualidadeRoute: typeof ARelatoriosAnaliseQualidadeRoute
  ARelatoriosCadastroProdutorRoute: typeof ARelatoriosCadastroProdutorRoute
  ARelatoriosCadastroProdutorSimpRoute: typeof ARelatoriosCadastroProdutorSimpRoute
  ARelatoriosColetasCidadeRoute: typeof ARelatoriosColetasCidadeRoute
  ARelatoriosEntradaLeiteRoute: typeof ARelatoriosEntradaLeiteRoute
  ARelatoriosFichaProdutorRoute: typeof ARelatoriosFichaProdutorRoute
  ARelatoriosFinanceiroProdutorRoute: typeof ARelatoriosFinanceiroProdutorRoute
  ARelatoriosFunruralRoute: typeof ARelatoriosFunruralRoute
  ARelatoriosLancamentosRoute: typeof ARelatoriosLancamentosRoute
  ARelatoriosLeiturasForaPadraoRoute: typeof ARelatoriosLeiturasForaPadraoRoute
  ARelatoriosLitragemColetaRoute: typeof ARelatoriosLitragemColetaRoute
  ARelatoriosLitragemMensalRoute: typeof ARelatoriosLitragemMensalRoute
  ARelatoriosPagamentoProdutorRoute: typeof ARelatoriosPagamentoProdutorRoute
  ARelatoriosProdutorFaixaLitragemRoute: typeof ARelatoriosProdutorFaixaLitragemRoute
  ARelatoriosReferenciaRoute: typeof ARelatoriosReferenciaRoute
  AAnalisesIndexLazyRoute: typeof AAnalisesIndexLazyRoute
  ABonificacoesIndexLazyRoute: typeof ABonificacoesIndexLazyRoute
  ACalculosIndexLazyRoute: typeof ACalculosIndexLazyRoute
  AColetasIndexLazyRoute: typeof AColetasIndexLazyRoute
  AConveniosIndexLazyRoute: typeof AConveniosIndexLazyRoute
  ADebugIndexLazyRoute: typeof ADebugIndexLazyRoute
  AEmpresas_conveniadasIndexLazyRoute: typeof AEmpresas_conveniadasIndexLazyRoute
  AFechamentoIndexLazyRoute: typeof AFechamentoIndexLazyRoute
  AGraficosIndexLazyRoute: typeof AGraficosIndexLazyRoute
  AMotoristaIndexLazyRoute: typeof AMotoristaIndexLazyRoute
  APainelGerencialIndexLazyRoute: typeof APainelGerencialIndexLazyRoute
  APreco_referenciaIndexLazyRoute: typeof APreco_referenciaIndexLazyRoute
  AProdutor_nfeIndexLazyRoute: typeof AProdutor_nfeIndexLazyRoute
  AProdutoresIndexLazyRoute: typeof AProdutoresIndexLazyRoute
  APropriedadeIndexLazyRoute: typeof APropriedadeIndexLazyRoute
  AReferenciasIndexLazyRoute: typeof AReferenciasIndexLazyRoute
  ARelatoriosIndexLazyRoute: typeof ARelatoriosIndexLazyRoute
  ARotasIndexLazyRoute: typeof ARotasIndexLazyRoute
  ASub_rotasIndexLazyRoute: typeof ASub_rotasIndexLazyRoute
  ASuporteIndexLazyRoute: typeof ASuporteIndexLazyRoute
  AUsuario_rotasIndexLazyRoute: typeof AUsuario_rotasIndexLazyRoute
  AVeiculoIndexLazyRoute: typeof AVeiculoIndexLazyRoute
}

const ARouteRouteChildren: ARouteRouteChildren = {
  AConfiguracaoEmpresaRouteRoute: AConfiguracaoEmpresaRouteRouteWithChildren,
  ARelatoriosAnaliseQualidadeRoute: ARelatoriosAnaliseQualidadeRoute,
  ARelatoriosCadastroProdutorRoute: ARelatoriosCadastroProdutorRoute,
  ARelatoriosCadastroProdutorSimpRoute: ARelatoriosCadastroProdutorSimpRoute,
  ARelatoriosColetasCidadeRoute: ARelatoriosColetasCidadeRoute,
  ARelatoriosEntradaLeiteRoute: ARelatoriosEntradaLeiteRoute,
  ARelatoriosFichaProdutorRoute: ARelatoriosFichaProdutorRoute,
  ARelatoriosFinanceiroProdutorRoute: ARelatoriosFinanceiroProdutorRoute,
  ARelatoriosFunruralRoute: ARelatoriosFunruralRoute,
  ARelatoriosLancamentosRoute: ARelatoriosLancamentosRoute,
  ARelatoriosLeiturasForaPadraoRoute: ARelatoriosLeiturasForaPadraoRoute,
  ARelatoriosLitragemColetaRoute: ARelatoriosLitragemColetaRoute,
  ARelatoriosLitragemMensalRoute: ARelatoriosLitragemMensalRoute,
  ARelatoriosPagamentoProdutorRoute: ARelatoriosPagamentoProdutorRoute,
  ARelatoriosProdutorFaixaLitragemRoute: ARelatoriosProdutorFaixaLitragemRoute,
  ARelatoriosReferenciaRoute: ARelatoriosReferenciaRoute,
  AAnalisesIndexLazyRoute: AAnalisesIndexLazyRoute,
  ABonificacoesIndexLazyRoute: ABonificacoesIndexLazyRoute,
  ACalculosIndexLazyRoute: ACalculosIndexLazyRoute,
  AColetasIndexLazyRoute: AColetasIndexLazyRoute,
  AConveniosIndexLazyRoute: AConveniosIndexLazyRoute,
  ADebugIndexLazyRoute: ADebugIndexLazyRoute,
  AEmpresas_conveniadasIndexLazyRoute: AEmpresas_conveniadasIndexLazyRoute,
  AFechamentoIndexLazyRoute: AFechamentoIndexLazyRoute,
  AGraficosIndexLazyRoute: AGraficosIndexLazyRoute,
  AMotoristaIndexLazyRoute: AMotoristaIndexLazyRoute,
  APainelGerencialIndexLazyRoute: APainelGerencialIndexLazyRoute,
  APreco_referenciaIndexLazyRoute: APreco_referenciaIndexLazyRoute,
  AProdutor_nfeIndexLazyRoute: AProdutor_nfeIndexLazyRoute,
  AProdutoresIndexLazyRoute: AProdutoresIndexLazyRoute,
  APropriedadeIndexLazyRoute: APropriedadeIndexLazyRoute,
  AReferenciasIndexLazyRoute: AReferenciasIndexLazyRoute,
  ARelatoriosIndexLazyRoute: ARelatoriosIndexLazyRoute,
  ARotasIndexLazyRoute: ARotasIndexLazyRoute,
  ASub_rotasIndexLazyRoute: ASub_rotasIndexLazyRoute,
  ASuporteIndexLazyRoute: ASuporteIndexLazyRoute,
  AUsuario_rotasIndexLazyRoute: AUsuario_rotasIndexLazyRoute,
  AVeiculoIndexLazyRoute: AVeiculoIndexLazyRoute,
}

const ARouteRouteWithChildren =
  ARouteRoute._addFileChildren(ARouteRouteChildren)

interface AuthRouteRouteChildren {
  AuthCadastroRoute: typeof AuthCadastroRoute
  AuthCadastroFimRoute: typeof AuthCadastroFimRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRecuperarSenhaRoute: typeof AuthRecuperarSenhaRoute
  AuthRedefinirSenhaRoute: typeof AuthRedefinirSenhaRoute
  AuthAcessoNegadoLazyRoute: typeof AuthAcessoNegadoLazyRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthCadastroRoute: AuthCadastroRoute,
  AuthCadastroFimRoute: AuthCadastroFimRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRecuperarSenhaRoute: AuthRecuperarSenhaRoute,
  AuthRedefinirSenhaRoute: AuthRedefinirSenhaRoute,
  AuthAcessoNegadoLazyRoute: AuthAcessoNegadoLazyRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ARouteRoute: ARouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  PErroIndexRoute: PErroIndexRoute,
  PApiDocsIndexLazyRoute: PApiDocsIndexLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
